import { loadRemoteModuleAsync } from '@anecdotes/architecture-tools';
import { Route } from '@angular/router';
import { ConfigurationFile } from '@anecdotes/configuration-data-access';
import { PluginRedirectionCallbackComponent } from './components';

export function routesFactory(config: ConfigurationFile, currentOrigin: string): Route[] {
  const routes: Route[] = [];

  const isGeneralOrigin = config.generalTenantUrl.toLowerCase() === currentOrigin.toLowerCase();

  // when current domain is not general domain or cross domain sign-in is not enabled
  if (!config.auth.crossDomainSignIn || isGeneralOrigin) {
    routes.push(
      {
        path: 'auth',
        loadChildren: () => loadRemoteModuleAsync('auth', (remoteEntry) => remoteEntry.AuthModule),
      }
    );
  }

  if (config.auth.crossDomainSignIn && isGeneralOrigin) {
    // when general domain - redirect to auth/sign-in for empty path
    routes.push({
      path: '',
      redirectTo: 'auth',
      pathMatch: 'prefix',
    });

    routes.push({
      path: 'plugins/:id',
      component: PluginRedirectionCallbackComponent,
    });
  }

  // when customers domain or not crossdomain
  if (!config.auth.crossDomainSignIn || !isGeneralOrigin) {
    routes.push({
      path: '',
      loadChildren: () => import('./modules/platform/platform.module').then(({ PlatformModule }) => PlatformModule),
    });
  }

  return routes;
}
